export default "__VITE_ASSET__BvXgx6A1__"